import React from 'react';
import { useTranslation } from 'react-i18next';

import check from '../../../assets/billingPayments/cash-payment-sign.svg';

import styles from './Reimbursement.module.css';

export const Check = ({ addressCheck = '' }) => {
  const { t } = useTranslation('insurance');

  return (
    <div className={styles.reimbursementMethodCard}>
      <img alt="check" src={check} />

      <span>{t('checkSent', { addressCheck })}</span>
    </div>
  );
};
